import * as ko from "knockout";
import * as localisationHelper from "localisationHelper";

import "@legend/knockout/binding/id";
import "@legend/knockout/binding/overriddenByTemplate";

// Models
import { SelectDropdownOptions } from "Content/ts/Models/Controls/inputSelectOptions";

import InputsBase, { IInputsBase } from "Content/ts/Shared/Inputs/inputs-base";

// Services
import { UniqueIdentifierServices } from "Content/ts/Shared/KnockoutBindings/Services/uniqueIdentifierServices";

export const Deps = {
    LocalisationHelper: localisationHelper
}

export interface IInputSelect extends IInputsBase {
    PlaceholderMessage: string;                                                                 // Optional
    TestId: string;                                                                             // Optional
    ShowCaption: boolean;                                                                       // Optional
    ShowLabel: boolean;                                                                         // Optional
    AriaLabel: string;                                                                          // Optional
    AriaDescribedById: string;                                                                          // Optional
    ElementId: string;                                                                          // Optional (Allows the html id attribute to be set)

    Options: Array<SelectDropdownOptions> | KnockoutObservableArray<SelectDropdownOptions>;     // Required
}

export default class InputSelect extends InputsBase {
    placeholderMessage: string;
    testId: string;
    showCaption: boolean;
    showLabel: boolean;
    ariaLabel: string;
    ariaDescribedById: string;
    uniqueIdentifier: string;
    options: Array<SelectDropdownOptions> | KnockoutObservableArray<SelectDropdownOptions>;

    constructor(params: IInputSelect) {
        super(params);

        // Provided Component Properties
        this.options = params.Options;
        this.ariaDescribedById = params.AriaDescribedById || "";
        this.placeholderMessage = params.PlaceholderMessage || Deps.LocalisationHelper.getString("GenericResources", "StandardSelectDefaultPlaceholderMessage");
        this.testId = params.TestId ?? '';
        this.showCaption = params.ShowCaption ?? true;
        this.showLabel = params.ShowLabel ?? true;
        this.ariaLabel = params.AriaLabel;
        this.uniqueIdentifier = params.ElementId ?? '';
        if (!this.uniqueIdentifier) {
            // auto generate the id if no custom element id has been passed in
            this.configureUniqueIdentifiers();
        }
    }

    setOptionBindings(option: Node, item: SelectDropdownOptions) {
        if (this.testId) {
            ko.applyBindingsToNode(option, { TestId: [this.testId, item ? item.Id || '' : 'placeholder'] }, item);
        }
    }

    private configureUniqueIdentifiers(): void {
        this.uniqueIdentifier = UniqueIdentifierServices.AddNewIdentifier(this.value);
        UniqueIdentifierServices.RemoveLinkHash(this.value);
    }
}

const componentName = "input-select";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: InputSelect,
    template: { require: `text!Content/ts/Shared/Inputs/Select/${componentName}.html` }
});